const StarIcon = (props) => {
  return (
    <svg width={22} height={21} fill="none" {...props}>
      <path
        d="M11 1l3.09 6.26L21 8.27l-5 4.87 1.18 6.88L11 16.77l-6.18 3.25L6 13.14 1 8.27l6.91-1.01L11 1z"
        stroke="#F9A62B"
      />
    </svg>
  );
}

export default StarIcon